import { styled } from "styled-components";

import { styleHeadingS } from "style/components/Typography";

export const Wrapper = styled.div`
    /* stylelint-disable no-empty-source */
`;

export const Heading = styled.h4`
    ${styleHeadingS};
    margin: 0 0 0.4375rem;
    text-decoration: underline;
`;
